export default "__VITE_ASSET__DMpIoaWc__"